import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'auth-layout-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class AuthLayoutMainComponent implements OnInit {
  constructor() {}
  ngOnInit() {}
}
